import { Heart } from "lucide-react";
import AppliedStatusIcon from "./AppliedStatusIcon";

function formatStatusCompletedAtFromIso(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const STATUS_LABELS = {
  applied: "Applied",
  saved: "Saved",
  "not-for-me": "Not for me",
};

/** Status pill row matching job search result cards. */
export default function ApplicantJobListStatusRow({ statusKey, timestampIso = "" }) {
  const key = String(statusKey || "").trim();
  const label = STATUS_LABELS[key];
  if (!label) return null;

  const iso = String(timestampIso || "").trim();
  const timeLabel = formatStatusCompletedAtFromIso(iso);
  const ariaParts = [label, timeLabel].filter(Boolean);

  return (
    <div
      className="job-search-result-status-row"
      role="group"
      data-interaction-status={key}
      aria-label={ariaParts.join(". ")}
    >
      <span className={`job-result-status status-${key}`} aria-hidden="true">
        {key === "saved" ? (
          <Heart
            className="job-result-status-icon job-result-status-icon--saved"
            size={16}
            strokeWidth={1.75}
            fill="currentColor"
            aria-hidden="true"
          />
        ) : key === "applied" ? (
          <AppliedStatusIcon className="job-result-status-icon" size={16} />
        ) : null}
      </span>
      <span className="job-result-status-label">{label}</span>
      {timeLabel ? (
        <time className="job-result-status-time" dateTime={iso}>
          {timeLabel}
        </time>
      ) : null}
    </div>
  );
}
